import { createQueryKeys } from "@lukemorales/query-key-factory";
import {GetAuditsRequest} from "@/Stub/V1";

export const Audits = createQueryKeys('audits', {
    list: (requestParams?: GetAuditsRequest) => [{ requestParams }],
});